import { Box, Button, Grid, TextField } from '@mui/material'
import { useFormik } from 'formik'
import React from 'react'
import { MdOutlineVerified } from 'react-icons/md'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as yup from "yup"
import { login } from '../../store/features/user/userSlice';

const OtpVerify = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    let loginSchema = yup.object({
        otp1: yup.number().required(''),
        otp2: yup.number().required(''),
        otp3: yup.number().required(''),
        otp4: yup.number().required(''),
        otp5: yup.number().required(''),
        otp6: yup.number().required(''),
    })
    const formik = useFormik({
        initialValues: {
        otp1: "",
        otp2: "",
        otp3: "",
        otp4: "",
        otp5: "",
        otp6: "",
        },
        validationSchema: loginSchema,
        onSubmit: (values) => {
            dispatch(login(values))
        }
    })

    const otpArray = ['otp1', 'otp2', 'otp3', 'otp4', 'otp5', 'otp6']

    // const inputChange = (value, setFieldValue, index, item) => {
    //     setFieldValue(item, value)
    // }
    
    const handleNavigate = () => {
        navigate("/")
    }

  return (
    <div className='bg-blue-950 border-blue-800 w-[350px] mt-[150px] mb-12 mx-auto p-8 border rounded-md shadow-md'>
        <div className='flex justify-center flex-col items-center pb-4'>
            <MdOutlineVerified className='text-blue-800 text-xl font-semibold' />
            <p className='text-white text-xl font-semibold'>Verify OTP</p>
            <span className='text-white'>Enter the 6-digit OTP we just send to your register email</span>
        </div>

        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={1}>
                {otpArray.map((item, index) => <Grid item xs={2} >
                    <TextField
                        id={index + 1}
                        size='small'
                        name={item[index + 1]}
                        fullWidth
                        onChange={(event) => {
                            const value = event.target.value.replace(/[^0-9]/g, "")
                            // inputChange(value, setFieldValue, index, item)
                        }}
                        value={formik.values.item}
                        onBlur={formik.handleBlur("item")}
                        inputProps={{ maxLength: 1, pattern: "[0-9]*" }}
                    />
                    <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                        {formik.touched.item && formik.errors.item ? (
                            <div>{formik.errors.item}</div>
                        ) : null}
                    </Box>
                </Grid>)}
                <Grid item xs={12} >
                    <Button
                        onClick={handleNavigate}
                        className='bg-[#9155FD] w-full'
                        type='submit'
                        variant='contained'
                        size='large'
                        sx={{padding: ".8rem 0", bgcolor: "#1e40af", "&:hover": {bgcolor: "#1e3a8a"}}}
                    >
                        Verify
                    </Button>
                </Grid>
            </Grid>
        </form>

        <div className='flex justify-center flex-col items-center pt-4'>
            <Button
                onClick={()=>navigate("/login")}
                variant='outlined'
                className='ml-5' size='small'
            >
                Back to Login
            </Button>
        </div>

    </div>
  )
}

export default OtpVerify
